import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-one-two-two',
  templateUrl: './two-one-two-two.component.html',
  styleUrls: ['./two-one-two-two.component.scss']
})
export class TwoOneTwoTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
